import React from 'react';

const footer = (props)=>(<div className="mynav" Style='postion: absolute; bottom: 3px; right: 3px;'>© 2018 Anthony Napolitano</div>)

export default footer;  


// WEBPACK FOOTER //
// ./src/container/Footer.js